import "./Menu.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TheEspressoBar from "./sections/TheEspressoBar";
import ProductsOfferings from "./sections/ProductsOfferings";
import Footer from "@/reusable_sections/Footer";
import Services from "./sections/Services";
export default function MenuPage() {
  return <div>
      <Header />
      <Hero />
      <TheEspressoBar />
      <Services />
      <ProductsOfferings />
      <Footer />
    </div>;
}